/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {EmailTemplateListPageComponent} from './email-template-list-page.component';

@Component({
  standalone: true,
  imports: [EmailTemplateListPageComponent],
  selector: 'adn-email-template-route-page',
  template: `
    <adn-email-template-list-page [readOnly]="readOnly"></adn-email-template-list-page>
  `
})
export class EmailTemplateRoutePageComponent {
  @Input() readOnly = false;
}
